import React from 'react';
import HomePage from '../components/home'

const Home = () => {
    return (
        <HomePage />
    )
}

export default Home;